import { useMutation, useQuery } from '@tanstack/react-query';
import { RoleType } from 'api/models';
import { TeamsAPI } from 'api/teams';
import { GENERAL_API_STALE } from 'config/query-config';
import { RolesApi } from 'data/roles';
import { useGetAllTeamsFromIndexedDb } from 'hooks/use-idb';
import { useTranslation } from 'hooks/use-translation';
export const ROLES_QUERY_KEY = [
    'account_roles'
];
export const ROLES_WITH_PLACEHOLDER_QUERY_KEY = [
    'account_roles_with_placeholder'
];
export const useCustomerRole = ()=>({
        roleId: -1,
        roleName: useTranslation('customer'),
        type: RoleType.Customer
    });
export const useRolesQuery = (queryOptions = {})=>useQuery(ROLES_QUERY_KEY, ()=>RolesApi.findAll(), {
        staleTime: GENERAL_API_STALE,
        ...queryOptions
    });
export const useVendorRolesQuery = (queryOptions = {})=>useRolesQuery({
        ...queryOptions,
        select: (data)=>data.filter(({ type })=>type === RoleType.Vendor)
    });
export const useRolesWithPlaceholderQuery = (queryOptions = {})=>{
    const teams = useGetAllTeamsFromIndexedDb();
    const roleIdsWithPlaceholder = teams.map((team)=>team === null || team === void 0 ? void 0 : team.roleId);
    return useQuery(ROLES_WITH_PLACEHOLDER_QUERY_KEY, async ()=>{
        const roles = await RolesApi.findAll();
        return roles.filter(({ roleId })=>roleIdsWithPlaceholder.includes(roleId));
    }, {
        staleTime: GENERAL_API_STALE,
        enabled: (roleIdsWithPlaceholder === null || roleIdsWithPlaceholder === void 0 ? void 0 : roleIdsWithPlaceholder.length) > 0,
        ...queryOptions
    });
};
export const useRolesWithPlaceholderQueryV2 = (queryOptions = {})=>{
    return useQuery(ROLES_WITH_PLACEHOLDER_QUERY_KEY, async ()=>{
        const roles = await RolesApi.findAll();
        const teams = await TeamsAPI.getAllTeamsInAccount();
        const roleIdsWithPlaceholder = teams.map((team)=>team === null || team === void 0 ? void 0 : team.roleId);
        return roles.filter(({ roleId })=>roleIdsWithPlaceholder.includes(roleId));
    }, {
        staleTime: GENERAL_API_STALE,
        ...queryOptions
    });
};
const createMutationFn = ({ roleName, usedByPartners, type })=>RolesApi.create({
        roleName,
        usedByPartners,
        type
    });
const createWithDefaultPlaceholderMutationFn = ({ roleName })=>RolesApi.createWithDefaultPlaceholder({
        roleName
    });
const updateMutationFn = (id, { roleName, usedByPartners, type })=>{
    return RolesApi.update(id, {
        roleName,
        usedByPartners,
        type
    });
};
export const useCreateRoleMutation = (options = {})=>useMutation(createMutationFn, options);
export const useUpdateRoleMutation = (id, options = {})=>useMutation((formValues)=>updateMutationFn(id, formValues), options);
export const useDeleteRoleMutation = (id, options = {})=>useMutation(()=>RolesApi.deleteRole(id), options);
export const useCreateRoleWithDefaultPlaceholderMutation = (options = {})=>useMutation(createWithDefaultPlaceholderMutationFn, options);
export const useMakeRolesAvailableForPartnersMutation = ()=>{
    return useMutation((roleIds)=>RolesApi.makeRolesAvailableForPartner(roleIds));
};
